// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"426":"audit","637":"order","907":"announcement","930":"task"}[chunkId] || chunkId) + "." + {"286":"36bd762e","426":"1b7f028f","592":"d223531b","637":"866a3753","871":"8c2b6fca","907":"8ea9feb0","930":"bc2d0612"}[chunkId] + ".css";
};